import { OwnerSubjectMetadataMessage } from '@/types/OwnerSubjectMetadata';

/**
 * Return the medium-size owner thumbnail URL, falling back to larger sizes if missing.
 * Order: mSize -> lSize -> sSize (standard) -> xSize -> ''.
 */
export function getOwnerMSizeThumb(owner: OwnerSubjectMetadataMessage): string {
  if (owner.msizeThumb) {
    return owner.msizeThumb;
  }
  if (owner.lsizeThumb) {
    return owner.lsizeThumb;
  }
  if (owner.ssizeThumb) {
    return owner.ssizeThumb;
  }
  if (owner.xsizeThumb) {
    return owner.xsizeThumb;
  }
  return '';
}

/**
 * Return the large-size owner thumbnail URL, falling back to the extra-large size if missing.
 * Order: lSize -> sSize (standard) -> xSize -> ''.
 */
export function getOwnerLSizeThumb(owner: OwnerSubjectMetadataMessage): string {
  if (owner.lsizeThumb) {
    return owner.lsizeThumb;
  }
  if (owner.ssizeThumb) {
    return owner.ssizeThumb;
  }
  if (owner.xsizeThumb) {
    return owner.xsizeThumb;
  }
  return '';
}